import { Box, Button, Flex, customStyled } from '@mafc/trolly';
import { RoundCornerButton } from 'common/styled/Button.style';

export const ItemCounterWrapper = customStyled(Box)(({ theme: { colors, fontSizes, space } }) => ({
  fontSize: fontSizes[2],
  padding: `10px ${space[3]}px`,
  backgroundColor: colors.GRAY_100,
  borderRadius: '48px',
  marginTop: space[3],
}));

export const ItemCounter = customStyled.span(({ theme: { fontWeights } }) => ({
  fontWeight: fontWeights[7],
}));

export const SubTitle = customStyled(Flex)(({ theme: { fontWeights, fontSizes, space } }) => ({
  fontWeight: fontWeights[7],
  fontSize: fontSizes[3],
  justifyContent: 'center',
  margin: `${space[3]}px ${space[2]}px ${space[2]}px`,
}));

export const RadioLabel = customStyled.label(() => ({
  cursor: 'pointer',
  display: 'flex',
}));

export const RadioButton = customStyled.input`
    width: 16px;
`;

export const Footer = customStyled(Box)(({ theme: { space, colors } }) => ({
  boxShadow: '0px -4px 30px 0px rgba(0, 0, 0, 0.15)',
  background: colors.white,
  bottom: 0,
  marginLeft: '-32px',
  padding: `${space[3]}px 0`,
  position: 'absolute',
  width: '100%',
}));

export const ButtonRow = customStyled(Flex)(({ theme: { space } }) => ({
  justifyContent: 'space-evenly',
}));

export const ErrorWrapper = customStyled(Box)(({ theme: { space } }) => ({
  margin: `${space[3]}px ${space[3]}px -${space[3]}px`,
}));

export const SkipButton = customStyled(Button)(({ theme: { colors, fontWeights } }) => ({
  color: colors.blue,
  fontWeight: fontWeights[7],
}));

export const ContinueButton = customStyled(RoundCornerButton)(() => ({
  width: '216px',
}));
